import React from "react";
import ThirdPartyServiceModel from "../../../models/thirdparty/ThirdPartyServiceModel";
import ThirdPartyServiceForm, {ThirdPartyServiceFormBody} from "../ThirdPartyServiceForm";
import {useTranslation} from "react-i18next";
import HTMLTextInput from "../../common/HTMLTextInput/HTMLTextInput";
import Collapsable from "../../common/Collapsable/Collapsable";

const initialState = {
    type: ThirdPartyServiceModel.Type.ECC,
    serviceName: '',
    enabled: true,
    description: '',
    whitelistedCertFingerprints: [],

    url: '',
    endpointType: ThirdPartyServiceModel.EndpointType.HTTPS,

    authenticationScope: ThirdPartyServiceModel.AuthenticationScope.SERVICE,
    authenticationMethod: ThirdPartyServiceModel.AuthenticationMethod.USERNAME_PASSWORD,
    authenticationServiceId: null
};

const allowedAuthenticationMethods = [
    ThirdPartyServiceModel.AuthenticationMethod.USERNAME_PASSWORD
];

function EccServiceForm() {
    return (
        <ThirdPartyServiceForm initialState={initialState} FormBody={EccServiceFormBody}/>
    )
}

export function EccServiceFormBody(props) {
    return (
        <ThirdPartyServiceFormBody {...props} FormBody={FormBody}
                                   allowedAuthenticationMethods={allowedAuthenticationMethods}/>
    )
}

function FormBody(props) {
    const {t} = useTranslation(['thirdPartyService']);
    const {
        thirdPartyService,
        inputHandler,
        isDisabled
    } = props;

    return (
        <Collapsable label={t('thirdPartyService:label.eccSettings')} isDisabled={isDisabled}>
            <div className="display-input">
                <HTMLTextInput label={t('thirdPartyService:label.url')} name={'url'}
                               value={thirdPartyService.url} onChange={inputHandler} isDisabled={isDisabled} isRequired/>
            </div>
        </Collapsable>
    )
}

export default EccServiceForm;
